import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/images/dirt_tires.jpg")